import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import Button from 'components/field/Button';
import Loading from 'components/global/Loading';
import ManageWidgetsModal from 'components/global/ManageWidgets/ManageWidgetsModal';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import PATHS, { mergePaths } from 'utils/paths';

import { faObjectsColumn } from '@fortawesome/pro-solid-svg-icons';

import { analysisChartsConfigRaw, chartsConfig } from './analysisWidgetsConfig';

/**
 * @author @omerrkosar
 */
const Analysis = () => {
	const tabs = useMemo(
		() => [
			{
				label: 'overview',
				path: mergePaths(PATHS.ANALYSIS, PATHS.ANALYSIS_TAB)
			},
			{
				label: 'analysisSLA',
				path: mergePaths(PATHS.ANALYSIS, PATHS.SLA_PERFORMANCE)
			},
			{
				label: 'analysisCarrierPerformance',
				path: mergePaths(PATHS.ANALYSIS, PATHS.DELIVERY_COMPANY)
			},
			{
				label: 'analysisShippingAccounting',
				path: mergePaths(PATHS.ANALYSIS, PATHS.SHIPPING_ACCOUNTING)
			},
			{
				label: 'sales',
				path: mergePaths(PATHS.ANALYSIS, PATHS.SALES)
			},
			{
				label: 'customerDetails',
				path: mergePaths(PATHS.ANALYSIS, PATHS.CUSTOMER_DETAILS)
			},
			{
				label: 'otoFlexAnalysis',
				path: mergePaths(PATHS.ANALYSIS, PATHS.OTO_FLEX)
			},
			{
				label: 'otoPack',
				path: mergePaths(PATHS.ANALYSIS, PATHS.OTO_PACK)
			}
		],
		[]
	);

	const data = chartsConfig(analysisChartsConfigRaw);
	return (
		<div>
			<PageHeader
				title="analysis"
				lordIcon="https://storage.googleapis.com/tryoto-public/lottie-files-compressed/analysis-icon-new.json.gz">
				<Button
					icon={faObjectsColumn}
					label={'manageWidgets.buttonLabel'}
					variant="blue"
					onClick={() =>
						NiceModal.show(ManageWidgetsModal, {
							data
						})
					}
				/>
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default Analysis;
